/* ZOMKI · El Armario
 * Conjunto puesto → perchero → tallas → compra.
 * Precios, variantes y disponibilidad llegan de Shopify en el JSON de cada conjunto.
 */
(function () {
  'use strict';

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency });
  function money(cents) { return fmt.format(cents / 100); }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EASE = 'cubic-bezier(.2,.8,.2,1)';

  function store(key, value) {
    try {
      if (value === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return null; }
  }
  function uniq(list) { return list.filter(function (v, i) { return list.indexOf(v) === i; }); }
  function lower(s) { return String(s || '').toLocaleLowerCase('es-ES'); }

  function Armario(el) {
    this.el = el;
    this.view = 'look';
    this.anims = [];
    this.sets = [];
    this.current = 0;
    this.guideCache = {};
    this.sheet = el.querySelector('[data-za-sheet]');
    this.guide = el.querySelector('[data-za-guide-dialog]');
    this.live = el.querySelector('[data-za-live]');
    var self = this;

    this.box = el.querySelector('[data-za-sets]') || el;
    el.querySelectorAll('[data-za-set]').forEach(function (node) { self.register(node); });
    if (!this.sets.length) return;

    el.classList.remove('za--nojs');
    el.classList.add('za--instant'); // restaurar el estado guardado sin animaciones
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('za--instant'); }); });
    this.measure();

    var savedView = store('za:view:' + el.id) || {};
    this.sets.forEach(function (s) { self.renderLookPrice(s); self.bindRack(s); });
    var savedIndex = this.indexOf(savedView.handle);
    if (savedIndex > 0) this.showSet(savedIndex, false);
    this.setView(savedView.view === 'rack' ? 'rack' : 'look', { animate: false });
    this.markRail();
    if (savedView.handle && savedIndex < 0) {
      var link = el.querySelector('[data-za-load="' + CSS.escape(savedView.handle) + '"]');
      if (link) this.loadSet(savedView.handle, null, savedView.view);
    }
    this.measure();
    this.watchFloating();
    // Con el navegador libre, se precargan las fotos y perchas de los demás conjuntos.
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    window.addEventListener('load', function () {
      idle(function () {
        el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      });
    });

    el.addEventListener('click', function (e) { self.onClick(e); });
    [this.sheet, this.guide].forEach(function (d) {
      if (!d) return;
      d.addEventListener('click', function (e) {
        if (e.target === d) d.close(); // toque fuera del panel
        if (e.target.closest('[data-za-close]')) { e.preventDefault(); d.close(); }
      });
      d.addEventListener('close', function () { document.documentElement.classList.remove('za-sheet-open'); });
    });
    if (this.sheet) this.bindSheet();
    window.addEventListener('resize', function () { self.measure(); }, { passive: true });
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.sets.forEach(function (s) { self.renderLookPrice(s); }); });
  }

  Armario.prototype.measure = function () {
    var top = this.el.getBoundingClientRect().top + window.scrollY;
    if (top >= 0 && top < 320) this.el.style.setProperty('--za-offset', Math.round(top) + 'px');
    // La foto ocupa lo que deja libre el panel: conjunto, precio y botones caben en la primera pantalla.
    var s = this.set && this.sets[this.current];
    var panel = s && s.node.querySelector('.za-panel');
    if (panel && this.view === 'look' && window.innerWidth < 990) {
      this.el.style.setProperty('--za-panel-h', Math.max(150, panel.offsetHeight) + 'px');
    }
  };

  // Mientras el Armario está en pantalla, el botón flotante del chat no tapa precio ni botones.
  Armario.prototype.watchFloating = function () {
    if (!('IntersectionObserver' in window)) return;
    var html = document.documentElement;
    new IntersectionObserver(function (entries) {
      html.classList.toggle('za-in-view', entries[0].intersectionRatio > 0.25);
    }, { threshold: [0, 0.25, 0.5] }).observe(this.el);
  };

  Armario.prototype.set = function () { return this.sets[this.current]; };

  Armario.prototype.register = function (node) {
    var data;
    try { data = JSON.parse(node.querySelector('[data-za-json]').textContent); } catch (e) { return null; }
    var saved = store('za:' + data.handle) || {};
    var s = {
      node: node,
      data: data,
      sizes: Array.isArray(saved.sizes) ? saved.sizes : [null, null],
      piece: saved.piece === 1 ? 1 : 0
    };
    node.dataset.zaSet = String(this.sets.length);
    node.querySelectorAll('[data-za-label]').forEach(function (chip) {
      var p = data.pieces[Number(chip.dataset.zaLabel)];
      if (p) chip.textContent = p.label;
    });
    this.sets.push(s);
    return s;
  };

  Armario.prototype.indexOf = function (handle) {
    if (!handle) return -1;
    for (var i = 0; i < this.sets.length; i++) if (this.sets[i].data.handle === handle) return i;
    return -1;
  };

  Armario.prototype.markRail = function () {
    var h = this.set().data.handle;
    this.el.querySelectorAll('[data-za-load]').forEach(function (a) {
      if (a.dataset.zaLoad === h) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  };

  // Carga la escena de cualquier conjunto desde su ficha (sección «Armario del conjunto»), sin recargar la página.
  Armario.prototype.loadSet = function (handle, link, view) {
    var self = this;
    var i = this.indexOf(handle);
    if (i >= 0) {
      this.showSet(i, false);
      this.revealStage(this.sets[i]);
      return;
    }
    if (this.loading) return;
    this.loading = true;
    if (link) link.setAttribute('aria-busy', 'true');
    this.say('Cargando el conjunto…');
    fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=zomki-armario-producto', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var art = doc.querySelector('[data-za-set]');
        if (!art) throw new Error('vacío');
        art = document.importNode(art, true);
        art.hidden = true;
        art.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        self.box.appendChild(art);
        var s = self.register(art);
        if (!s) throw new Error('datos');
        self.renderLookPrice(s);
        self.bindRack(s);
        if (view) self.view = view;
        self.showSet(self.sets.length - 1, false);
        if (link) self.revealStage(s);
      })
      .catch(function () { if (link) window.location.href = link.href; })
      .then(function () {
        self.loading = false;
        if (link) link.removeAttribute('aria-busy');
      });
  };

  Armario.prototype.save = function (s) {
    store('za:' + s.data.handle, { sizes: s.sizes, piece: s.piece });
    store('za:view:' + this.el.id, { handle: s.data.handle, view: this.view });
  };

  Armario.prototype.say = function (msg) {
    if (!this.live) return;
    this.live.textContent = '';
    var live = this.live;
    setTimeout(function () { live.textContent = msg; }, 30);
  };

  /* ---------- Datos ---------- */
  Armario.prototype.findSetVariant = function (s) {
    var sz = s.sizes;
    if (!sz[0] || !sz[1]) return null;
    return s.data.variants.filter(function (v) { return v.options[0] === sz[0] && v.options[1] === sz[1]; })[0] || null;
  };
  Armario.prototype.pieceVariant = function (piece, size) {
    if (!size) return null;
    var list = piece.variants.filter(function (v) { return v.options[piece.sizeIndex] === size; });
    return list.filter(function (v) { return v.available; })[0] || list[0] || null;
  };
  Armario.prototype.pieceSizes = function (piece) {
    return uniq(piece.variants.map(function (v) { return v.options[piece.sizeIndex]; }));
  };
  // Ahorro real: suma de las prendas sueltas en las mismas tallas menos el precio del conjunto.
  Armario.prototype.savingFor = function (s, variant) {
    if (!variant) return null;
    var self = this, total = 0, ok = true;
    s.data.pieces.forEach(function (p, i) {
      var pv = self.pieceVariant(p, variant.options[i]);
      if (!pv) ok = false; else total += pv.price;
    });
    if (!ok || total <= variant.price) return null;
    return { separate: total, saving: total - variant.price };
  };
  Armario.prototype.cheapest = function (s) {
    var av = s.data.variants.filter(function (v) { return v.available; });
    var list = av.length ? av : s.data.variants;
    return list.reduce(function (a, b) { return b.price < a.price ? b : a; }, list[0]);
  };

  Armario.prototype.renderLookPrice = function (s) {
    var chosen = this.findSetVariant(s);
    var v = chosen || this.cheapest(s);
    var prices = uniq(s.data.variants.map(function (x) { return x.price; }));
    var priceEl = s.node.querySelector('[data-za-set-price]');
    var saveEl = s.node.querySelector('[data-za-set-save]');
    var line = s.node.querySelector('[data-za-setline-price]');
    var label = (!chosen && prices.length > 1 ? 'Desde ' : '') + money(v.price);
    if (priceEl) priceEl.textContent = label;
    if (line) line.textContent = label;
    var sv = this.savingFor(s, v);
    var st = s.node.querySelector('[data-za-sticker]');
    if (st) {
      if (sv) { st.innerHTML = 'Ahorras<b>' + money(sv.saving) + '</b>'; st.hidden = false; } else st.hidden = true;
    }
    if (saveEl) {
      if (sv) {
        saveEl.innerHTML = 'Por separado <s>' + money(sv.separate) + '</s> · <b>Ahorras ' + money(sv.saving) + '</b>';
        saveEl.hidden = false;
      } else { saveEl.hidden = true; }
    }
  };

  /* ---------- Vistas ---------- */
  Armario.prototype.showSet = function (index, focus) {
    if (index === this.current || !this.sets[index]) return;
    this.anims.forEach(function (a) { a.cancel(); });
    this.sets[this.current].node.hidden = true;
    this.current = index;
    var s = this.sets[index];
    s.node.hidden = false;
    this.setView(this.view, { animate: false, force: true });
    this.save(s);
    this.markRail();
    this.measure();
    if (focus) {
      var sw = s.node.querySelector('.za-switch [aria-pressed="true"]');
      if (sw) sw.focus({ preventScroll: true });
    }
    this.say('Conjunto: ' + s.data.title);
  };

  Armario.prototype.setView = function (view, opts) {
    opts = opts || {};
    if (view === this.view && !opts.force) return;
    var s = this.set();
    var node = s.node;
    var look = node.querySelector('[data-za-look]');
    var animate = opts.animate !== false && !reduceMotion.matches && look && typeof look.animate === 'function';

    // Medir antes de cancelar: si una transición estaba a medias, se parte de donde está ahora.
    var first = animate ? look.getBoundingClientRect() : null;
    this.anims.forEach(function (a) { a.cancel(); });
    this.anims = [];

    this.view = view;
    this.el.dataset.view = view;
    var isRack = view === 'rack';
    node.querySelectorAll('[data-za-panel="look"]').forEach(function (p) { p.hidden = isRack; });
    node.querySelectorAll('[data-za-panel="rack"]').forEach(function (p) { p.hidden = !isRack; });
    node.querySelectorAll('.za-switch [data-za-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.zaView === view));
    });
    var rack = node.querySelector('[data-za-rack]');
    rack.setAttribute('aria-hidden', String(!isRack));
    rack.querySelectorAll('button').forEach(function (b) { b.tabIndex = isRack ? 0 : -1; });
    node.querySelector('.za-look__back').tabIndex = isRack ? 0 : -1;

    if (isRack) {
      this.renderPiece(s);
      s.items.forEach(function (it, i) { it.firstElementChild.setAttribute('aria-pressed', String(i === s.piece)); });
      this.centerPiece(s, false);
    }
    this.save(s);

    if (!animate) return;
    var last = look.getBoundingClientRect();
    if (!last.width || !last.height) return;
    var dx = first.left - last.left, dy = first.top - last.top;
    var sx = first.width / last.width, sy = first.height / last.height;
    this.anims.push(look.animate(
      [{ transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')' }, { transform: 'none' }],
      { duration: 560, easing: EASE }
    ));
    if (isRack) {
      var self = this;
      node.querySelectorAll('.za-hanger__swing').forEach(function (h, i) {
        self.anims.push(h.animate([
          { transform: 'translateY(-28px) rotate(-9deg)', opacity: 0 },
          { transform: 'translateY(0) rotate(4deg)', opacity: 1, offset: 0.65 },
          { transform: 'rotate(0deg)', opacity: 1 }
        ], { duration: 640, delay: 160 + i * 90, easing: EASE, fill: 'backwards' }));
      });
    }
  };

  /* ---------- Perchero ---------- */
  Armario.prototype.bindRack = function (s) {
    var self = this;
    var track = s.node.querySelector('[data-za-track]');
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-za-item]'));
    var swings = track.querySelectorAll('.za-hanger__swing');
    var lastX = track.scrollLeft, lastT = performance.now(), frame = 0, idle = 0;
    s.track = track; s.items = items;

    function paint() {
      frame = 0;
      var mid = track.scrollLeft + track.clientWidth / 2;
      items.forEach(function (it) {
        var d = Math.min(1, Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid) / it.offsetWidth);
        var btn = it.firstElementChild;
        btn.style.setProperty('--za-s', (1 - 0.18 * d).toFixed(3));
        btn.style.setProperty('--za-o', (1 - 0.42 * d).toFixed(3));
      });
      if (!reduceMotion.matches) {
        var now = performance.now();
        var v = (track.scrollLeft - lastX) / Math.max(16, now - lastT);
        var r = Math.max(-7, Math.min(7, -v * 5));
        swings.forEach(function (sw) { sw.style.setProperty('--za-r', r.toFixed(2) + 'deg'); });
        lastX = track.scrollLeft; lastT = now;
      }
    }
    function settle() {
      swings.forEach(function (sw) { sw.style.setProperty('--za-r', '0deg'); });
      if (self.set() !== s || self.view !== 'rack' || s.programmatic) return;
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (it, i) {
        var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      if (best !== s.piece) self.selectPiece(s, best, { scroll: false });
    }
    track.addEventListener('scroll', function () {
      if (!frame) frame = requestAnimationFrame(paint);
      clearTimeout(idle);
      idle = setTimeout(function () { s.programmatic = false; settle(); }, 140);
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var next = s.piece + (e.key === 'ArrowRight' ? 1 : -1);
      if (next < 0 || next >= items.length) return;
      self.selectPiece(s, next, { scroll: true });
      items[next].firstElementChild.focus({ preventScroll: true });
    });
  };

  Armario.prototype.centerPiece = function (s, smooth) {
    var it = s.items[s.piece];
    if (!it) return;
    s.programmatic = true;
    var left = it.offsetLeft - (s.track.clientWidth - it.offsetWidth) / 2;
    s.track.scrollTo({ left: left, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
    if (!smooth) setTimeout(function () { s.programmatic = false; }, 50);
  };

  Armario.prototype.selectPiece = function (s, index, opts) {
    s.piece = index;
    s.items.forEach(function (it, i) { it.firstElementChild.setAttribute('aria-pressed', String(i === index)); });
    if (opts.scroll) this.centerPiece(s, true);
    this.renderPiece(s);
    this.updateArrows(s);
    this.save(s);
    this.say(s.data.pieces[index].label + ' seleccionado');
  };

  Armario.prototype.updateArrows = function (s) {
    var prev = s.node.querySelector('[data-za-step="-1"]'), next = s.node.querySelector('[data-za-step="1"]');
    if (prev) prev.disabled = s.piece === 0;
    if (next) next.disabled = s.piece === s.items.length - 1;
  };

  Armario.prototype.renderPiece = function (s) {
    var self = this;
    var p = s.data.pieces[s.piece];
    var n = s.node;
    var size = s.sizes[s.piece];
    var sizes = this.pieceSizes(p);
    if (size && sizes.indexOf(size) === -1) size = null;
    var v = this.pieceVariant(p, size);
    var minPrice = Math.min.apply(null, p.variants.map(function (x) { return x.price; }));
    var varies = uniq(p.variants.map(function (x) { return x.price; })).length > 1;

    n.querySelector('[data-za-piece-kicker]').textContent = 'Prenda ' + (s.piece + 1) + ' de ' + s.data.pieces.length + ' · ' + p.label;
    n.querySelector('[data-za-piece-name]').textContent = p.title;
    n.querySelector('[data-za-piece-price]').textContent = v ? money(v.price) : (varies ? 'Desde ' : '') + money(minPrice);
    n.querySelector('[data-za-piece-legend]').textContent = 'Talla · ' + p.label;
    var link = n.querySelector('[data-za-piece-link]');
    link.href = p.url;
    link.setAttribute('aria-label', 'Ver detalles de ' + p.title);
    n.querySelector('[data-za-piece-error]').textContent = '';

    var box = n.querySelector('[data-za-piece-chips]');
    box.setAttribute('role', 'radiogroup');
    box.setAttribute('aria-label', 'Talla de ' + p.label);
    box.innerHTML = '';
    sizes.forEach(function (value) {
      var available = p.variants.some(function (x) { return x.options[p.sizeIndex] === value && x.available; });
      box.appendChild(self.chip(value, value === size, available, function () {
        if (!available) {
          n.querySelector('[data-za-piece-error]').textContent = 'Talla ' + value + ' agotada (' + lower(p.label) + '). Elige otra talla.';
          return;
        }
        s.sizes[s.piece] = value;
        self.save(s);
        self.renderPiece(s);
        self.renderLookPrice(s);
        var again = n.querySelector('[data-za-piece-chips] [data-value="' + CSS.escape(value) + '"]');
        if (again) again.focus();
      }));
    });

    var add = n.querySelector('[data-za-add-piece]');
    add.textContent = 'Añadir ' + lower(p.label);
    this.updateArrows(s);
  };

  Armario.prototype.chip = function (value, checked, available, onPick) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'za-size';
    b.dataset.value = value;
    b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', String(checked));
    if (!available) {
      b.setAttribute('aria-disabled', 'true');
      b.setAttribute('aria-label', value + ', agotada');
      b.innerHTML = '<span></span><small>Agotada</small>';
      b.firstChild.textContent = value;
    } else {
      b.textContent = value;
    }
    b.addEventListener('click', onPick);
    return b;
  };

  /* ---------- Compra ---------- */
  Armario.prototype.addToCart = function (variantId, button, busyLabel) {
    var self = this;
    var label = button.textContent;
    if (button.getAttribute('aria-busy') === 'true') return Promise.reject(new Error('busy'));
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = busyLabel;
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'No hemos podido añadirlo al carrito.');
        return j;
      });
    }).then(function (j) {
      self.refreshCartCount();
      return j;
    }).finally(function () {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = label;
    });
  };

  Armario.prototype.refreshCartCount = function () {
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble__text-count, [data-zomki-field="count"]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        document.querySelectorAll('.cart-bubble').forEach(function (el) {
          el.classList.toggle('visually-hidden', cart.item_count === 0);
          el.hidden = false;
        });
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'zomki-armario', data: { source: 'zomki-armario', itemCount: cart.item_count } }
        }));
      }).catch(function () {});
  };

  Armario.prototype.addPiece = function () {
    var s = this.set(), p = s.data.pieces[s.piece], n = s.node;
    var err = n.querySelector('[data-za-piece-error]');
    var size = s.sizes[s.piece];
    var v = this.pieceVariant(p, size);
    if (!size || !v) {
      err.textContent = 'Elige una talla de ' + lower(p.label) + ' para añadirla.';
      var firstChip = n.querySelector('[data-za-piece-chips] .za-size:not([aria-disabled])');
      if (firstChip) firstChip.focus();
      return;
    }
    if (!v.available) { err.textContent = 'Esa talla está agotada. Elige otra.'; return; }
    err.textContent = '';
    var self = this;
    this.addToCart(v.id, n.querySelector('[data-za-add-piece]'), 'Añadiendo…').then(function () {
      self.openDone(p.title + ' · Talla ' + size + ' · ' + money(v.price), 'Prenda añadida');
    }).catch(function (e) { if (e.message !== 'busy') err.textContent = e.message; });
  };

  /* Panel de compra del conjunto */
  Armario.prototype.bindSheet = function () {
    var self = this;
    this.sheet.querySelector('[data-za-sheet-add]').addEventListener('click', function () { self.addSet(); });
  };

  Armario.prototype.openSheet = function () {
    var s = this.set();
    var d = this.sheet;
    d.querySelector('[data-za-done]').hidden = true;
    d.querySelector('.za-sheet__summary').hidden = false;
    d.querySelector('[data-za-sheet-body]').hidden = false;
    d.querySelector('[data-za-sheet-title]').textContent = s.data.title;
    var thumb = d.querySelector('[data-za-sheet-thumb]');
    if (s.data.image) { thumb.src = s.data.image; thumb.hidden = false; } else thumb.hidden = true;
    d.querySelector('[data-za-sheet-error]').textContent = '';
    this.renderSheet();
    document.documentElement.classList.add('za-sheet-open');
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    var firstChip = d.querySelector('.za-size[aria-checked="true"]') || d.querySelector('.za-size:not([aria-disabled])');
    if (firstChip) firstChip.focus();
  };

  Armario.prototype.renderSheet = function () {
    var self = this, s = this.set(), d = this.sheet;
    var body = d.querySelector('[data-za-sheet-body]');
    body.innerHTML = '';
    s.data.options.forEach(function (optName, i) {
      var piece = s.data.pieces[i] || { label: optName };
      var fs = document.createElement('fieldset');
      fs.className = 'za-sizes';
      fs.innerHTML = '<legend class="za-sizes__legend"><span></span><button type="button" class="za-link">Guía de tallas</button></legend>' +
        '<div class="za-sizes__list" role="radiogroup"></div><p class="za-error" role="alert"></p>';
      fs.querySelector('legend span').textContent = optName;
      fs.querySelector('legend button').addEventListener('click', function () { self.openGuide(i); });
      var list = fs.querySelector('.za-sizes__list');
      list.setAttribute('aria-label', optName);
      var values = uniq(s.data.variants.map(function (v) { return v.options[i]; }));
      var other = s.sizes[1 - i];
      values.forEach(function (value) {
        var available = s.data.variants.some(function (v) {
          return v.options[i] === value && v.available && (!other || v.options[1 - i] === other);
        });
        list.appendChild(self.chip(value, s.sizes[i] === value, available, function () {
          if (!available) {
            fs.querySelector('.za-error').textContent = 'Talla ' + value + ' agotada (' + lower(piece.label) + ')' + (other ? ' en esta combinación' : '') + '. Elige otra.';
            return;
          }
          s.sizes[i] = value;
          self.save(s);
          self.renderSheet();
          self.renderLookPrice(s);
          var again = d.querySelectorAll('.za-sizes')[i].querySelector('[data-value="' + CSS.escape(value) + '"]');
          if (again) again.focus();
        }));
      });
      body.appendChild(fs);
    });

    var v = this.findSetVariant(s);
    var shown = v || this.cheapest(s);
    var prices = uniq(s.data.variants.map(function (x) { return x.price; }));
    d.querySelector('[data-za-sheet-total]').textContent = (!v && prices.length > 1 ? 'Desde ' : '') + money(shown.price);
    var sv = this.savingFor(s, shown);
    d.querySelector('[data-za-sheet-save]').innerHTML = sv
      ? 'Por separado costaría <s>' + money(sv.separate) + '</s> · <b>ahorras ' + money(sv.saving) + '</b>'
      : '';
    var add = d.querySelector('[data-za-sheet-add]');
    add.textContent = v ? 'Añadir conjunto · ' + money(v.price) : 'Añadir conjunto';
  };

  Armario.prototype.addSet = function () {
    var self = this, s = this.set(), d = this.sheet;
    var sets = d.querySelectorAll('.za-sizes');
    var missing = false;
    s.data.options.forEach(function (name, i) {
      var e = sets[i] && sets[i].querySelector('.za-error');
      if (!s.sizes[i]) {
        missing = true;
        if (e) e.textContent = 'Elige la ' + lower(name) + '.';
      } else if (e) e.textContent = '';
    });
    var err = d.querySelector('[data-za-sheet-error]');
    if (missing) {
      err.textContent = 'Te falta elegir una talla para cada prenda.';
      var firstEmpty = d.querySelector('.za-sizes .za-error:not(:empty)');
      if (firstEmpty) { var c = firstEmpty.parentNode.querySelector('.za-size:not([aria-disabled])'); if (c) c.focus(); }
      return;
    }
    var v = this.findSetVariant(s);
    if (!v || !v.available) { err.textContent = 'Esta combinación de tallas está agotada. Prueba con otra.'; return; }
    err.textContent = '';
    this.addToCart(v.id, d.querySelector('[data-za-sheet-add]'), 'Añadiendo conjunto…').then(function () {
      var parts = s.data.pieces.map(function (p, i) { return p.label + ' ' + s.sizes[i]; }).join(' · ');
      self.showDone(s.data.title + ' · ' + parts + ' · ' + money(v.price), 'Conjunto añadido');
    }).catch(function (e) { if (e.message !== 'busy') err.textContent = e.message; });
  };

  Armario.prototype.showDone = function (text, title) {
    var d = this.sheet;
    d.querySelector('[data-za-sheet-body]').hidden = true;
    d.querySelector('.za-sheet__summary').hidden = true;
    d.querySelector('[data-za-done]').hidden = false;
    d.querySelector('[data-za-done-title]').textContent = title;
    d.querySelector('[data-za-done-text]').textContent = text;
    d.querySelector('[data-za-done-title]').focus();
    this.say(title + ': ' + text);
  };

  Armario.prototype.openDone = function (text, title) {
    var d = this.sheet;
    var s = this.set();
    d.querySelector('[data-za-sheet-title]').textContent = s.data.title;
    var thumb = d.querySelector('[data-za-sheet-thumb]');
    if (s.data.image) thumb.src = s.data.image;
    if (!d.open) {
      document.documentElement.classList.add('za-sheet-open');
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    }
    this.showDone(text, title);
  };

  /* Guía de tallas: tabla de medidas de la propia prenda (descripción del producto en Shopify) */
  Armario.prototype.openGuide = function (pieceIndex) {
    var self = this, s = this.set();
    var p = s.data.pieces[pieceIndex == null ? s.piece : pieceIndex];
    var g = this.guide;
    if (!g || !p) return;
    g.querySelector('[data-za-guide-title]').textContent = p.title;
    var body = g.querySelector('[data-za-guide-body]');
    body.textContent = 'Cargando medidas…';
    if (typeof g.showModal === 'function') { if (!g.open) g.showModal(); } else g.setAttribute('open', '');
    var cached = this.guideCache[p.handle];
    var job = cached ? Promise.resolve(cached) : fetch(ROOT + 'products/' + encodeURIComponent(p.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (prod) {
        var doc = new DOMParser().parseFromString(prod.description || '', 'text/html');
        doc.querySelectorAll('script, style, iframe').forEach(function (x) { x.remove(); });
        var tables = doc.querySelectorAll('table');
        var html = '';
        if (tables.length) {
          tables.forEach(function (t) {
            var prev = t.previousElementSibling;
            if (prev && /^H[2-6]$|^P$/.test(prev.tagName) && prev.textContent.length < 140) html += prev.outerHTML;
            html += t.outerHTML;
          });
        }
        self.guideCache[p.handle] = html;
        return html;
      });
    job.then(function (html) {
      if (html) body.innerHTML = html;
      else body.textContent = 'Las medidas de esta prenda están en su ficha y en la guía completa de tallas.';
    }).catch(function () {
      body.textContent = 'No hemos podido cargar las medidas. Consulta la guía completa de tallas.';
    });
  };

  // Si la escena quedó fuera de la pantalla (por ejemplo al tocar el botón de abajo), se vuelve a mostrar.
  Armario.prototype.revealStage = function (s) {
    var stage = s.node.querySelector('.za-stage');
    var header = document.querySelector('#header-component');
    var top = header ? header.getBoundingClientRect().bottom : 0;
    var r = stage.getBoundingClientRect();
    if (r.top < top - 4 || r.top > window.innerHeight * 0.4) {
      window.scrollTo({ top: window.scrollY + r.top - Math.max(0, top), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
  };

  /* ---------- Eventos ---------- */
  Armario.prototype.onClick = function (e) {
    var t = e.target;
    var viewBtn = t.closest('[data-za-view]');
    var s = this.set();
    if (viewBtn && this.el.contains(viewBtn)) {
      e.preventDefault();
      var wanted = viewBtn.dataset.zaView;
      var fromPanel = !viewBtn.closest('.za-switch');
      this.setView(wanted);
      this.revealStage(s);
      if (fromPanel) {
        var target = wanted === 'rack'
          ? s.node.querySelector('.za-hanger[aria-pressed="true"]')
          : s.node.querySelector('.za-switch [data-za-view="rack"]');
        if (target) target.focus({ preventScroll: true });
      }
      this.say(wanted === 'rack' ? 'Mostrando las prendas del conjunto' : 'Mostrando el conjunto completo');
      return;
    }
    var hanger = t.closest('[data-za-piece]');
    if (hanger) {
      var pi = Number(hanger.dataset.zaPiece);
      // Tocar la prenda ya elegida lleva directamente a su ficha.
      if (pi === s.piece && this.view === 'rack' && s.data.pieces[pi]) { window.location.href = s.data.pieces[pi].url; return; }
      this.selectPiece(s, pi, { scroll: true });
      return;
    }
    var step = t.closest('[data-za-step]');
    if (step) {
      var next = s.piece + Number(step.dataset.zaStep);
      if (next >= 0 && next < s.items.length) this.selectPiece(s, next, { scroll: true });
      return;
    }
    var load = t.closest('[data-za-load]');
    if (load) { e.preventDefault(); this.loadSet(load.dataset.zaLoad, load); return; }
    if (t.closest('[data-za-buy-set]')) { e.preventDefault(); this.openSheet(); return; }
    if (t.closest('[data-za-add-piece]')) { this.addPiece(); return; }
    if (t.closest('[data-za-guide]')) { this.openGuide(); return; }
  };

  function init() {
    document.querySelectorAll('[data-za]').forEach(function (el) {
      if (el.__za) return;
      el.__za = new Armario(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
